import React from 'react';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/cartSlice';
import { getLegalCopy } from '../utils/legalTranslations';
import LegalDocument from './LegalDocument';

const GeneralTerms = () => {
  const selectedLang = useSelector(selectLanguage) || { code: 'en' };
  const copy = getLegalCopy(selectedLang.code || 'en');

  return (
    <LegalDocument
      heading={copy.terms.heading}
      subtitle={copy.terms.subtitle}
      sections={copy.terms.sections}
      companyLabels={copy.company}
    />
  );
};

export default GeneralTerms;
